<template>
  <div class="root_node">
    <div class="container">
      <div class="tc">
        <Header tln="project" v-slot:imgname><img src="../assets/banner/about.jpg" alt="" /></Header>
        <PageContent v-slot:pc>
          <dl class="page_list">
            <dt class="pl_title">
              <p><span>ABOUT</span></p>
              <p><sapn>关于我们</sapn></p>
            </dt>
            <dd class="pl_content">
              <p class="mb_40"><strong>新意. FRESH COO</strong>是以品牌设计及产品供货、安装售后的集合型创新公司。<br />我们专注于品牌形象设计与星级酒店、城市商业综合体、城市公共设施、景区度假村等导视系统&amp;公共艺术装置的策划、设计、制作、安装、售后维护的全程式服务。<br />我们由资深策划、设计精英及专业生产团队组成。团队成员有着多元化的专业背景，丰富的工程管理经验，以及成熟稳健的项目实操能力；我们拥有一套完善科学的管理体制，快捷准确的研发能力，积极稳妥的供货渠道和完善的项目管理机制。<br />新意. FRESH COO 以前瞻的国际视野和生产研发实力追求卓越；我们致力为客户设计独一无二的国际化品牌形象，打造导视系统杰出典范及优质创新的公共艺术品，让您在市场竞争中脱颖而出、如虎添翼，助梦成真。</p>
              <p class="mb_40"><strong>新意 / 品牌</strong>以品牌为核心，提供兼具想象力和商业竞争力的品牌综合服务；从专业的品牌策略、创意、设计到跨界创意互联。我们追求实现创意与解决商业问题的有机结合，擅长运用跨界的设计思维与跨领域的设计手段，为品牌打造独特的整体形象。</p>
              <p class="mb_40"><strong>新意 / 导视</strong>专注于顶级酒店、度假村、城市商业综合体、旅游综合体、国家4A/5A风景区及森林公园、市政公共建筑、大型产业园区、地产项目等导示系统、标识系统专业设计、制作、安装、售后维护全程式服务。我们以品牌体验、品牌理念的视角设计导示系统，使导示系统设计充分传递品牌价值。</p>
              <p class="mb_100"><strong>新意 / 装置</strong>我们的服务涵盖了艺术、地产、建筑、工程技术、文化等不同领域。根据客户的项目定位、目标效应及成本控制等量身定制艺术品方案，同时，专业的艺术管理经验和技术制作把控，也使我们能够兑现将艺术品完美呈现的承诺，为客户提供全方位、一体化的艺术服务。 热爱艺术和思考的我们，创造出更多具有审美价值的公共艺术作品。</p>
            </dd>
          </dl>
          <div class="ad">
            <img src="../assets/images/about/logo-ditu.jpg" alt="" />
            <div class="ad_page_content">
              <dl class="page_list">
                <dt class="pl_title">
                  <p><span>HISTORY</span></p>
                  <p><span>新意历程</span></p>
                </dt>
                <dd class="pl_content"></dd>
              </dl>
            </div>
          </div>
          <div class="ad"><img src="../assets/images/about/logo-ditu-2.jpg" alt="" /></div>
          <dl class="page_list client_wrapper">
            <dt class="pl_title">
              <p><span>CLIENT</span></p>
              <p><sapn>服务客户</sapn></p>
            </dt>
            <dd class="pl_content">
              <dl>
                <dt class="plc_title plc_title_24">
                  <p><span>HAPPY PARTNERS WHO WORK WITH US</span><br /><sapn>一路同行，感谢有你</sapn></p>
                </dt>
                <dd class="plc_content">
                  <ul class="client_list">
                  	<li v-for="(item, index) in clientDatas" :key="item.id" :id="item.id" v-if="item.id != 'n'" class="client_title"><span @mouseover="clientFocus(item.id)" @mouseleave="clientBlur(item.id)">{{item.post_title}}</span></li>
                    <li style="line-height:1;" v-else><span>&nbsp;</span></li>
                  </ul>
                  <div class="client_logo"><img :src="clientLogo" alt="" /></div>
                </dd>
              </dl>
            </dd>
          </dl>
        </PageContent>
      </div>
      <Footer tln="four"></Footer>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import Header from "../components/common/Header";
  import PageContent from "../components/common/PageContent";
  import Footer from "../components/common/Footer";
  export default {
    name: 'Introduction',
    data: function() {
      return {
        clientDatas: [],
        clientLogo: '',
        itemNull: false
      }
    },
    mounted:function(){
      axios.get("/xy_api/home.php?page=client").then(res => {
        if(res.status == 200) {
          //数据样式
          let rdc = res.data.clientDatas;
          let carr = [];
          for(let i = 0; i < rdc.length; i++) {
            if(rdc[i+1] && rdc[i].post_excerpt == rdc[i+1].post_excerpt) {
              carr.push(rdc[i]);
            }else{
              carr.push(rdc[i]);
              carr.push({id:'n',post_title:" ",guid:''});
            }
          }
          this.clientDatas = carr;
          //初始设置
          if(this.clientDatas.length > 0) {
            this.clientLogo = this.clientDatas[0].guid;
          }
        }
      }).catch(err => {
        console.log(err);
      })
    },
    components: { Header, PageContent, Footer },
    methods: {
      clientFocus: function(clientId) {
        for(let item of this.clientDatas) {
          if(item.id == clientId) {
            this.clientLogo = item.guid;
          }
        }
      },
      clientBlur: function(clientId) {

      },
      listN: function(i) {
        console.log("li序列号：" + i);
      }
    }
  }
</script>

<style type="text/less" lang="less">
  @import url("../assets/css/base.less");
  .client_wrapper {
    padding: 2.083vw 0 5.208vw 0;
    position: relative;
    z-index: 1;
    .pl_content {
      padding-left: 19.792vw;
      .client_list {
        height: 23vw;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        .client_title {
          font-size: 1.143em;
          line-height: 1.3;
          width: 8em;
          margin: 0 2.5em 0.7em 0;
          span:hover {
            border-bottom: solid thin rgba(0,0,0,0.85);
            cursor: default;
          }
        }
      }
      .client_logo {
        width: 23.438vw;
        height: 13.021vw;
        overflow: hidden;
        position: absolute;
        z-index: 2;
        top: 10.417vw;
        left: 5vw;
        img {
          display: block;
          height: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Introduction.vue